import { MonoTypeOperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  Object.prototype.toString.call(value) === '[object Object]';

const toCamelCaseKey = (key: string): string => key.replace(/[-_]+([a-zA-Z0-9])/g, (_, char: string) => char.toUpperCase());

const toSnakeCaseKey = (key: string): string =>
  key
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toLowerCase();

const transformKeysDeep = (value: unknown, keyTransformer: (key: string) => string): unknown => {
  if (Array.isArray(value)) {
    return value.map((item) => transformKeysDeep(item, keyTransformer));
  }

  if (isPlainObject(value)) {
    return Object.entries(value).reduce<Record<string, unknown>>((acc, [key, val]) => {
      acc[keyTransformer(key)] = transformKeysDeep(val, keyTransformer);
      return acc;
    }, {});
  }

  return value;
};

export const toCamelcase = <T>(): MonoTypeOperatorFunction<T> => map((obj) => transformKeysDeep(obj, toCamelCaseKey) as T);
export const toSnakecase = <T>(): MonoTypeOperatorFunction<T> => map((obj) => transformKeysDeep(obj, toSnakeCaseKey) as T);
export const toCamelcaseFun = <T>(obj: T): T => transformKeysDeep(obj, toCamelCaseKey) as T;
export const toSnakecaseFun = <T>(obj: T): T => transformKeysDeep(obj, toSnakeCaseKey) as T;
